import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { Button } from 'primeng/button';
import { LAST_ACTIVITY_STORAGE_KEY } from '../../../app.component';

@Component({
  selector: 'app-signed-out',
  templateUrl: './signed-out.component.html',
  styleUrls: ['./signed-out.component.scss'],
  imports: [Button, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SignedOutComponent {
  private router = inject(Router);

  signIn(): void {
    localStorage.setItem(LAST_ACTIVITY_STORAGE_KEY, Date.now().toString());
    this.router.navigateByUrl('/webcapture');
  }
}
